import { render, staticRenderFns } from "./front-single-form.vue?vue&type=template&id=2b25c012&scoped=true&"
import script from "./front-single-form.vue?vue&type=script&lang=js&"
export * from "./front-single-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b25c012",
  null
  
)

export default component.exports